import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../engineering-systems-constants';

export type FeatureStructure = {
  imgSrc: string;
  alt: string;
  description: string;
};

export const FEATURES_LIST: FeatureStructure[] = [
  {
    imgSrc: `${ENGINEERING_SYSTEMS_CDN_PATH}/heating/1.svg/1.svg`,
    alt: 'График установки оборудования',
    description: 'Установим оборудование в\u00A0удобное для вас время',
  },
  {
    imgSrc: `${ENGINEERING_SYSTEMS_CDN_PATH}/advantages/2.svg/2.svg`,
    alt: 'Индивидуальное решение',
    description: 'Подберём индивидуальное решение с\u00A0учётом всех пожеланий и\u00A0бюджета',
  },
  {
    imgSrc: `${ENGINEERING_SYSTEMS_CDN_PATH}/features/3.svg/3.svg`,
    alt: 'Проект',
    description: 'Разработаем проект, составим смету и\u00A0список товаров',
  },
  {
    imgSrc: `${ENGINEERING_SYSTEMS_CDN_PATH}/advantages/3.svg/3.svg`,
    alt: 'Весь цикл работ',
    description: 'Выполняем весь цикл работ от\u00A0замера до\u00A0монтажа',
  },
  {
    imgSrc: `${ENGINEERING_SYSTEMS_CDN_PATH}/advantages/1.svg/1.svg`,
    alt: 'Гарантия от Лемана ПРО',
    description: '1\u00A0год гарантии от\u00A0Лемана\u00A0ПРО на\u00A0установку оборудования',
  },
];
